// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import myAccountFilterSectionStyles from "@guestsupply/App/SharedStyles/MyAccountPages/List/MyAccountFilterSectionStyles";
import { filterStyles } from "@guestsupply/Overrides/Widgets/InvoiceHistory/InvoiceHistoryFilter";
import { mergeWithCss, xScreen } from "@guestsupply/XDL/Utilities";
import { hideElement } from "@guestsupply/XDL/Utilities";
import { GridItemStyle } from "@insite/mobius/GridItem/GridItem";
import { css } from "styled-components";

filterStyles.container = {
    ...mergeWithCss(myAccountFilterSectionStyles.searchFormStyles.wrapper, {
        offsetCss: css`
            &&& {
                width: 100%;
                margin: 0;
            }
        `,
        css: css`
            padding: 10px 15px;
            ${GridItemStyle} {
                padding: 10px;
                align-items: center;
            }
        `,
    }),
};

filterStyles.headingItem = {
    css: css`
        ${hideElement}
    `,
};

filterStyles.fromGridItem = filterStyles.toGridItem = {
    ...mergeWithCss(myAccountFilterSectionStyles.smallGridItem, {
        css: css`
            &&&& {
                align-items: baseline;
            }
        `,
    }),
};

filterStyles.clearFiltersButton = {
    ...myAccountFilterSectionStyles.clearButton,
};

filterStyles.buttonsItem = {
    width: [12, 6, 8, 12, 4],
    css: css`
        &&& {
            justify-content: flex-end;
            align-items: flex-end;
        }
    `,
};

filterStyles.onlyOpenGridItem = {
    width: [12, 6, 4, 3, 4],
    align: "middle",
    css: css`
        > div {
            margin-top: 24px;
            ${xScreen("lte", "md")} {
                margin-top: 0;
            }
        }
        padding-top: 0;
    `,
};

filterStyles.shipToGridItem = {
    width: [12, 6, 6, 6, 4],
};

filterStyles.invoiceNumberGridItem = {
    width: [12, 6, 3, 3, 3],
};

filterStyles.orderNumberGridItem = {
    width: [12, 6, 3, 3, 3],
};

filterStyles.poNumberGridItem = {
    width: [12, 6, 3, 3, 2],
};

filterStyles.appliedFilterTag = {
    ...myAccountFilterSectionStyles.appliedFilterTag,
};
